import Seo, { breadcrumbLd, localBusinessLd } from "../lib/seo";
import { SITE, IMG } from "../lib/site";
import { Breadcrumbs } from "../components/site/Layout";
import { Reveal, Overline } from "../components/site/Reveal";
import QuoteForm from "../components/site/QuoteForm";
import { Phone, Mail, MapPin, Globe, MessageCircle } from "lucide-react";

export default function Contact() {
  const mapsQuery = encodeURIComponent("Sharjah Media City, Sharjah, UAE");
  return (
    <>
      <Seo title="Contact NanoMax Holo Solutions in Sharjah, UAE | Get a Quote"
        description="Contact NanoMax Holo Solutions in Sharjah Media City for custom hologram stickers and security labels. Call or WhatsApp +971 58 5378822 or request a free quote."
        path="/contact" image={IMG.hero} jsonLd={[localBusinessLd, breadcrumbLd([{ name: "Home", path: "/" }, { name: "Contact", path: "/contact" }])]} />
      <Breadcrumbs items={[{ name: "Home", path: "/" }, { name: "Contact" }]} />
      <section className="px-6 md:px-10 lg:px-16 pt-10 md:pt-16 pb-14 border-b border-white/10">
        <Reveal>
          <Overline>Contact</Overline>
          <h1 className="font-head font-black uppercase tracking-tighter leading-[0.95] text-4xl md:text-5xl lg:text-6xl mt-5 max-w-4xl">Contact NanoMax Holo Solutions in Sharjah, UAE</h1>
          <p className="text-base md:text-lg text-[#8A8A9B] mt-6 max-w-2xl leading-relaxed">Tell us about your product and security requirements. Our UAE-based team will review your enquiry and get back to you shortly.</p>
        </Reveal>
      </section>

      <section className="px-6 md:px-10 lg:px-16 py-16 grid lg:grid-cols-5 gap-10">
        <div className="lg:col-span-2 space-y-6">
          <Reveal>
            <div className="card p-8">
              <div className="font-head font-black tracking-tighter text-xl">{SITE.legal}</div>
              <div className="mt-6 space-y-4 text-sm">
                <div className="flex items-start gap-3 text-[#C9C9D4]"><MapPin size={16} className="text-holo-cyan mt-0.5" /> {SITE.address}</div>
                <a href={`tel:${SITE.phoneRaw}`} className="flex items-center gap-3 text-[#C9C9D4] hover:text-holo-cyan transition-colors" data-testid="contact-phone"><Phone size={16} className="text-holo-cyan" /> {SITE.phone}</a>
                <a href={`mailto:${SITE.email}`} className="flex items-center gap-3 text-[#C9C9D4] hover:text-holo-cyan transition-colors" data-testid="contact-email"><Mail size={16} className="text-holo-cyan" /> {SITE.email}</a>
                <a href={SITE.domain} className="flex items-center gap-3 text-[#C9C9D4] hover:text-holo-cyan transition-colors"><Globe size={16} className="text-holo-cyan" /> nanomax.ae</a>
              </div>
              <div className="mt-8 flex flex-col gap-3">
                <a href={SITE.whatsapp} target="_blank" rel="noreferrer" className="btn-primary px-6 py-3.5 text-sm flex items-center justify-center gap-2" data-testid="contact-whatsapp"><MessageCircle size={16} /> Chat on WhatsApp</a>
                <a href={`tel:${SITE.phoneRaw}`} className="btn-ghost px-6 py-3.5 text-sm text-center">Call Us</a>
              </div>
            </div>
          </Reveal>
          <Reveal delay={0.1}>
            <div className="card overflow-hidden">
              <iframe title="NanoMax Holo Solutions location" width="100%" height="260" style={{ border: 0, filter: "grayscale(1) invert(0.9) contrast(0.85)" }} loading="lazy" src={`https://maps.google.com/maps?q=${mapsQuery}&output=embed`}></iframe>
            </div>
          </Reveal>
        </div>
        <div className="lg:col-span-3">
          <Reveal delay={0.05}>
            <Overline className="mb-5">Request a Free Hologram Sticker Quote</Overline>
            <QuoteForm sourcePage="/contact" />
          </Reveal>
        </div>
      </section>
    </>
  );
}
